// extracted by mini-css-extract-plugin
export default {"downloadPdf":"DownloadPdf_downloadPdf__VxKpZ","textRow":"DownloadPdf_textRow__ZJFiH","actionsRow":"DownloadPdf_actionsRow__y8pfh"};